<template>
  <div class="d-scrollable-content">
    <div
      :id="`scrollable-items-${ _uid }`"
      ref="scrollableItems"
      class="d-scrollable-items"
    >
      <slot name="content" />
    </div>

    <DuiScrollAvailable
      v-once
      :ref-element-id="`scrollable-items-${ _uid }`"
    />
  </div>
</template>

<script>
export default {
  methods: {
    getScrollingItemsRef() {
      return this.$refs.scrollableItems;
    },

    resetScroll() {
      this.$refs.scrollableItems.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-scrollable-content {
  height: 100%;
  overflow: hidden;
  position: relative;

  &:before,
  &:after {
    content: " ";
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  &:before {
    background-image: linear-gradient(to top, $color-transparent-white, getColor($white));
    height: $_2em;
    top: 0;
  }

  &:after {
    background-image: linear-gradient(to bottom, $color-transparent-white, getColor($white));
    bottom: 0;
    height: $_4em;
  }

  .d-scrollable-items {
    box-sizing: border-box;
    max-height: 100%;
    overflow: auto;
    padding-bottom: $_4em;
    padding-top: $_2em;
    -webkit-overflow-scrolling: touch;

    @include scrollBar();
  }
}
</style>
